import React, {useState, useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {Helper} from "../../../tools/Helper";
import {api_Routes} from "../../../tools/api_Routes";
import {
    errorToaster,
    successToaster,
} from "../../../helper/toasterConfiguration";
import {Button, CircularProgress, Container} from "@mui/material";
import LogoSelect from "./logo-select";
import Contacts from "./contacts";
import MainDetails from "./main-details";
import {Styles} from "./styles";
import SliderSelect from "./slider-select";
import {ability} from "../../../config/acl/ability";

const EditPanelForm = ({
                           formData,
                           setFormData,
                           payment_method,
                           countries,
                           currencies,
                           users,               // new
                           isUsersLoading,
                       }) => {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [uploadOption, setUploadOption] = useState(
        formData?.logo ? "logo" : "customLogo"
    );
    const [uploadSliderOption, setUploadSliderOption] = useState(
        formData?.screenshot_urls && formData?.screenshot_urls?.length > 0
            ? "enterUrls"
            : formData?.photos && formData?.photos.length > 0
            ? "uploadImages"
            : "uploadImages" // Default option
    );
    const canEditPanelUrl = ability.can('panel_url', 'update')
    const [selectedFont, setSelectedFont] = useState(
        formData?.customLogo && formData?.customLogo["fontFamily"]
    );
    const [selectedColor, setSelectedColor] = useState(
        formData?.customLogo && formData?.customLogo["color"]
    );
    const [selectedBgColor, setSelectedBgColor] = useState(
        formData?.logo_bg_color && formData?.logo_bg_color
    );
    const [logoName, setLogoName] = useState(
        formData?.customLogo && formData?.customLogo["logoName"]
    );
    const [fontSize, setFontSize] = useState(
        formData?.customLogo && formData?.customLogo["fontSize"]?.replace("px", "")
    );
    const [inputValue, setInputValue] = useState("");
    const [paymentMethod, setPaymentMethod] = useState(payment_method);

    const handleChange = (key, value) => {
        setFormData((prev) => ({...prev, [key]: value}));
    };

    const handleCoursesChange = (event, value) => {
        setFormData((prev) => ({
            ...prev,
            country_id: value ? value?.id : "",
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // const requiredFields = [
        //   "smmpanel_name",
        //   "smmpanel_url",
        // ];

        const updatedFormData = {
            ...formData,
        };

        // const missingFields = requiredFields.filter(
        //     (field) => !updatedFormData[field]
        // );

        // if (uploadOption === "logo") {
        //   if (!formData.logo) {
        //     missingFields.push("logo");
        //   }
        // } else if (uploadOption === "customLogo") {
        //   // Validate individual properties for custom logo
        //   if (!logoName || !selectedColor || !selectedFont || !fontSize) {
        //     missingFields.push(
        //         "customLogo properties (logoName, color, fontFamily, fontSize)"
        //     );
        //   }
        // }

        // if (uploadSliderOption === "enterUrls") {
        //   if (!updatedFormData.screenshot_urls || updatedFormData.screenshot_urls.length === 0) {
        //     missingFields.push("screenshot_urls");
        //   }
        // } else if (uploadSliderOption === "uploadImages") {
        //   if (!updatedFormData.photos || updatedFormData.photos.length === 0) {
        //     missingFields.push("photos");
        //   }
        // }

        // if (missingFields.length > 0) {
        //   errorToaster(
        //       `Please fill in all required fields: ${missingFields.join(", ")}`
        //   );
        //   setIsLoading(false);
        //   return;
        // }

        setIsLoading(true);

        const form_data = new FormData();

        // Append form data based on the active upload option
        if (
            uploadOption === "logo" &&
            formData.logo &&
            typeof formData.logo !== "string"
        ) {
            form_data.append("logo", formData.logo);
        } else if (uploadOption === "customLogo") {
            updatedFormData.customLogo = {
                fontSize: `${fontSize}px`,
                color: selectedColor,
                fontFamily: selectedFont,
                logoName: logoName,
            };
            Object.keys(updatedFormData.customLogo).forEach((key) => {
                form_data.append(`customLogo[${key}]`, updatedFormData.customLogo[key]);
            });
        }
        console.log(updatedFormData)
        // Append other form data fields
        Object.keys(updatedFormData).forEach((key) => {

            const value = updatedFormData[key];
            if (value && key !== "logo" && key !== "customLogo") {
                if (key === "screenshot_urls" && uploadSliderOption === "enterUrls") {
                    // Append screenshot_urls as an array if it exists
                    if (Array.isArray(value) && value.length > 0) {
                        value.forEach((url, index) => {
                            form_data.append(`screenshot_urls[${index}]`, url);
                        });
                    }
                } else if (key === "photos" && uploadSliderOption === "uploadImages") {
                    // Append photos as an array
                    if (Array.isArray(value) && value.length > 0) {
                        value.forEach((photo, index) => {
                            if (photo instanceof File) {
                                // New uploaded photo
                                form_data.append(`photos[${index}]`, photo);
                            } else if (typeof photo === "object" && photo.photo_url) {
                                // Existing photo URL
                                form_data.append(`photos[${index}]`, photo.photo_url);
                            }
                        });
                    }
                } else if (key === "paymentMethod") {
                    // Append payment methods as an array
                    if (Array.isArray(value)) {
                        value.forEach((method, index) => {
                            form_data.append(`paymentMethod[${index}]`, method);
                        });
                    }
                } else if (key === "logo_bg_color") {
                    console.log('tttttttttttttttttttttttttttttttttttttt')
                    // Append payment methods as an array
                    form_data.append("logo_bg_color", selectedBgColor);
                } else {
                    form_data.append(key, value);
                }
            }
        });
        if (!form_data.get("logo_bg_color")) {
            form_data.append("logo_bg_color", selectedBgColor);
        }

        const result = await Helper.Post({
            url: api_Routes.Panels.Edit + id,
            data: form_data,
            hasToken: true,
        });

        const {response, message} = result || {};

        if (response) {
            successToaster(message);
            // navigate("/Panels");
        }
        setIsLoading(false);
    };

    return (
        <Styles>
            <Container>
                <form onSubmit={handleSubmit} className="main-container">
                    <div className="data-container">
                        <MainDetails
                            handleChange={handleChange}
                            formData={formData}
                            countries={countries}
                            currencies={currencies}
                            handleCoursesChange={handleCoursesChange}
                            users={users}               // new
                            isUsersLoading={isUsersLoading} // new
                        />
                        <Contacts
                            formData={formData}
                            handleChange={handleChange}
                            paymentMethod={paymentMethod}
                            setPaymentMethod={setPaymentMethod}
                            inputValue={inputValue}
                            setInputValue={setInputValue}
                        />
                    </div>
                    <LogoSelect
                        formData={formData}
                        setFormData={setFormData}
                        uploadOption={uploadOption}
                        setUploadOption={setUploadOption}
                        logoName={logoName}
                        setLogoName={setLogoName}
                        selectedFont={selectedFont}
                        setSelectedFont={setSelectedFont}
                        selectedColor={selectedColor}
                        setSelectedColor={setSelectedColor}
                        setSelectedBgColor={setSelectedBgColor}
                        selectedBgColor={selectedBgColor}
                        fontSize={fontSize}
                        setFontSize={setFontSize}
                    />
                    <SliderSelect
                        formData={formData}
                        setFormData={setFormData}
                        uploadOption={uploadSliderOption}
                        setUploadOption={setUploadSliderOption}
                    />
                    <div className="submit-btn">
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <CircularProgress size={22} sx={{color: "white"}}/>
                            ) : (
                                "Submit"
                            )}
                        </Button>
                    </div>
                </form>
            </Container>
        </Styles>
    );
};

export default EditPanelForm;
